import cnh from '~/helpers/cnh';
import useTranslation from '~/hooks/useTranslation';
import getInTouchStyles from '~/styles/myEnvironment/get-in-touch.module.css';
import Button from '../General/Button';

type Props = {
  className?: string;
  email: string;
  subject?: string;
};

export default function GetInTouch({
  className,
  email,
  subject,
}: Props) {
  const translate = useTranslation();

  return (
    <div className={cnh(getInTouchStyles.getInTouch, className)}>
      <h2 className={getInTouchStyles.title}>
        {translate('myEnvironment.get_in_touch.title')}
      </h2>

      <div className={getInTouchStyles.content}>
        {translate('myEnvironment.get_in_touch.content')}
      </div>

      <Button type="link" href={`mailto:${email}?subject=${subject ?? ''}`}>
        {translate('myEnvironment.get_in_touch.button')}
      </Button>
    </div>
  );
}
